import { render, staticRenderFns } from "./ButtonReactivate.vue?vue&type=template&id=1767fe2a&"
import script from "./ButtonReactivate.vue?vue&type=script&lang=ts&"
export * from "./ButtonReactivate.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonReactivate.vue?vue&type=style&index=0&id=1767fe2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports